// extracted by mini-css-extract-plugin
export default {"recos":"d7-z","productCardOverride":"e7-z","rowHasBadge":"f7-z"};